<template>
    <div style="display:none"></div>
</template>
<script>
import flowxo from '../plugins/flowxo';

export default {
    props: {
        user_id: {
            type: String,
            required: true
        },
        extra_info: {
            type: Object,
            default: () => ({})
        }
    },
    async onUmounted() {
        await flowxo.destroy()
    },
    computed: {  
        refresh_token() {
            return this.$store.state.refresh_token;
        },
        relacao() {
            return this.$store.getters.relacao;
        },
        condominio() {
            return this.$store.getters.condominio;
        },
        cliente() {
            return this.$store.state.cliente;
        }
    },
    watch: {
        user_id: {
            immediate: true,
            async handler() {
                await flowxo.setConfig({
                    externalUserId: this.user_id,
                    metadata: {
                        myUserId: this.extra_info.codigo,
                        condominio: this.condominio.codigo,
                        tipo_relacao: this.relacao.tipoRelacao,
                        token: this.refresh_token,
                    }
                })
                //await flowxo.create()
            }
        }
    }
}

</script>